'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_FormQuantity$QuantityEquals$squantsQuantity() {
}
export { $c_Lapp_data_FormQuantity$QuantityEquals$squantsQuantity as $c_Lapp_data_FormQuantity$QuantityEquals$squantsQuantity };
$p = $c_Lapp_data_FormQuantity$QuantityEquals$squantsQuantity.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_FormQuantity$QuantityEquals$squantsQuantity;
/** @constructor */
function $h_Lapp_data_FormQuantity$QuantityEquals$squantsQuantity() {
}
export { $h_Lapp_data_FormQuantity$QuantityEquals$squantsQuantity as $h_Lapp_data_FormQuantity$QuantityEquals$squantsQuantity };
$h_Lapp_data_FormQuantity$QuantityEquals$squantsQuantity.prototype = $p;
$p.bVp = (function(a1, a2) {
  return (a1.rW() === a2.rW());
});
$p.bVo = (function(a1, a2) {
  var x = a1.oT();
  var x$2 = a2.oT();
  return ((x === null) ? (x$2 === null) : x.f(x$2));
});
$p.auj = (function(a1, a2) {
  return this.bVp(a1, a2);
});
$p.aui = (function(a1, a2) {
  return this.bVo(a1, a2);
});
var $d_Lapp_data_FormQuantity$QuantityEquals$squantsQuantity = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_FormQuantity$QuantityEquals$squantsQuantity, "app.data.FormQuantity$QuantityEquals$squantsQuantity", ({
  DI: 1,
  jv: 1
}));
export { $d_Lapp_data_FormQuantity$QuantityEquals$squantsQuantity as $d_Lapp_data_FormQuantity$QuantityEquals$squantsQuantity };
//# sourceMappingURL=app.data.-Form-Quantity$-Quantity-Equals$squants-Quantity.js.map
